import { ToothChartStage } from '@/components/dental/ToothChartStage';
import { ShortcutsPanel } from '@/components/dental/shortcuts/ShortcutsPanel';
import { useShortcutMode } from '@/components/dental/shortcuts/ShortcutModeContext';
import { PlanPanel } from '@/components/dental/plan/PlanPanel';

// ── Props ─────────────────────────────────────────────────────────────────────

interface PlanRouteProps {
  patientId: string;
  clinicId: string;
}

// ── Component ─────────────────────────────────────────────────────────────────

export function PlanRoute({ patientId, clinicId }: PlanRouteProps) {
  const { activeShortcutId, toggleShortcut } = useShortcutMode();

  return (
    <div className="flex h-full overflow-hidden">
      {/* Left rail: shortcuts */}
      <ShortcutsPanel
        clinicId={clinicId}
        activeShortcutId={activeShortcutId}
        onShortcutToggle={toggleShortcut}
        className="w-[220px] shrink-0"
      />

      {/* Main column: chart + plan panel */}
      <div className="flex flex-1 min-w-0 flex-col overflow-hidden">
        {/* Chart (takes ~60% height, shrinks to min-content) */}
        <div className="flex-none p-4 lg:p-6">
          <ToothChartStage
            patientId={patientId}
            clinicId={clinicId}
            activeShortcutId={activeShortcutId}
          />
        </div>

        {/* Plan panel (scrollable, max 40vh) */}
        <div className="border-t border-slate-200 dark:border-slate-700 flex-1 min-h-0 overflow-hidden">
          <PlanPanel
            patientId={patientId}
            clinicId={clinicId}
            className="h-full"
          />
        </div>
      </div>
    </div>
  );
}
